import styles from "./todo.module.css";
import { RiDeleteBin6Fill } from "react-icons/ri";
const Todo = ({
  todo,
  onDelete,
  key,
  handleAddress,
  addressId,
  todos,
  index,
}) => {
  return (
    <div
      className="d-flex my-1 align-items-baseline form-check "
      onClick={() => {
        handleAddress(todo.id);
        console.log(todos[index]);
      }}
    >
      <input
        className="form-check-input me-2"
        checked={addressId == todo.id ? true : false}
        type="radio"
        name="flexRadioDefault"
        id={`flexRadioDefault${index}`}
      ></input>
      <label
        class="form-check-label d-flex flex-column w-100"
        for={`flexRadioDefault${index}`}
      >
        <div className={`${styles.todoContainer1}`} key={todo.id}>
          <div className="w-100">
            <div className="d-flex flex-wrap">
              <h6 className={`${styles.titleAddress}`}>{todo.title}</h6>
              <p className={`${styles.textMobile}`}>
                شماره تماس: {todo.mobile}
              </p>
            </div>
            <p className={`${styles.textAddress}`}> {todo.address}</p>
          </div>

          <div>
            <button
              className={styles.md}
              onClick={() => {
                onDelete();
              }}
            >
              <RiDeleteBin6Fill />
            </button>
          </div>
        </div>
      </label>
    </div>
  );
};

export default Todo;
